import { create } from 'zustand';

/**
 * Estado do `/logout` depois do "Sair" (revisão E16 da C8). A memória já foi limpa e a tela já
 * está no login; daqui sai só o que a tela de login mostra:
 *
 * - `idle`: nada pendente.
 * - `pending`: o `/logout` está em voo.
 * - `failed`: a API não confirmou; a tela mostra o erro e o "Tentar de novo". A marca do "Sair"
 *   explícito (`lib/explicit-logout.ts`) impede que a sessão volte sozinha pelo cookie.
 */
export type SignOutStatus = 'idle' | 'pending' | 'failed';

interface SignOutState {
  status: SignOutStatus;
}

export const useSignOutStore = create<SignOutState>()(() => ({ status: 'idle' }));

/**
 * Access da sessão que está saindo, só em memória, para o "Tentar de novo" repetir o `/logout`.
 * Nunca vai para storage; some no sucesso, no próximo login ou ao recarregar a página.
 */
let leavingAccessToken: string | null = null;

/** Cada "Sair" (e cada login) abre uma geração; o desfecho de uma geração velha é ignorado. */
let generation = 0;

export function signOutGeneration(): number {
  return generation;
}

export function beginSignOut(accessToken: string | null): void {
  generation += 1;
  leavingAccessToken = accessToken;
  useSignOutStore.setState({ status: 'pending' });
}

export function leavingSessionAccessToken(): string | null {
  return leavingAccessToken;
}

export function setSignOutStatus(status: SignOutStatus): void {
  if (status === 'idle') leavingAccessToken = null;
  useSignOutStore.setState({ status });
}

/** O operador entrou de novo (ou o teste terminou): nada de "Sair" pendente. */
export function forgetPendingSignOut(): void {
  generation += 1;
  setSignOutStatus('idle');
}
